import React from "react";
import { motion } from "framer-motion";
import { Zap, Shield } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

export const Experience = () => {
  const { t } = useLang();
  return (
    <section id="experience" className="relative py-24 lg:py-32 bg-[#08080A] border-y border-white/10 overflow-hidden" data-testid="experience-section">
      <div className="orb w-96 h-96 bg-[#00F0FF]/10 right-0 top-0" />
      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="text-xs tracking-[0.2em] uppercase font-mono text-cyan mb-4">{t("experience_eyebrow")}</div>
          <h2 className="font-head font-bold text-4xl sm:text-5xl lg:text-6xl tracking-tight text-white">
            <span className="text-cyan glow-text">420</span> {t("experience_title").replace(/^420\s*/, "")}
          </h2>
          <p className="mt-5 text-base text-zinc-400">{t("experience_subtitle")}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="card-glow rounded-2xl p-8"
            data-testid="experience-young"
          >
            <div className="w-12 h-12 rounded-xl bg-[#FF0055]/10 border border-[#FF0055]/30 flex items-center justify-center mb-6">
              <Zap size={22} className="text-[#FF0055]" />
            </div>
            <h3 className="font-head font-semibold text-2xl text-white mb-3">{t("young_title")}</h3>
            <p className="text-zinc-400 leading-relaxed">{t("young_desc")}</p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
            className="card-glow rounded-2xl p-8"
            data-testid="experience-old"
          >
            <div className="w-12 h-12 rounded-xl bg-[#00F0FF]/10 border border-[#00F0FF]/30 flex items-center justify-center mb-6">
              <Shield size={22} className="text-cyan" />
            </div>
            <h3 className="font-head font-semibold text-2xl text-white mb-3">{t("old_title")}</h3>
            <p className="text-zinc-400 leading-relaxed">{t("old_desc")}</p>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
